import { FC, useState } from 'react';
import './SidebarUsersFilter.scss';
import SidebarFilter from '../../../../components/SidebarFilter/SidebarFilter';
import { useForm } from 'react-hook-form';
import { Col, FormGroup, Row } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { useUsers } from '../../../../providers/Access/Users/UsersProvider';
import { customStyles } from '../../../../models/SelectCustomStyles';
import InputSearchPartner from '../../../InputSearchPartner/InputSearchPartner';

interface SidebarUsersFilterProps { }

const statusOptions = [
  { value: true, label: 'Ativo' },
  { value: false, label: 'Inativo' },
];

// @ts-ignore
export const defaultValues = {
  name: '',
  email: '',
} as any;

const SidebarUsersFilter: FC<SidebarUsersFilterProps> = () => {
  const { handleSubmit, register, setValue, control } = useForm<any>({ defaultValues });

  const { setParams, userTypesOptions } = useUsers();

  const [userFilterType, setUserFilterType] = useState<'code' | 'name'>('code');
  const [valuePartner, setValuePartner] = useState<any>();
  const [selectedStatus, setSelectedStatus] = useState<any | null>(null);
  const [selectedUserType, setSelectedUserType] = useState<any | null>(null);

  const onSubmit = async (data: any) => {
    const filter: any = {};

    if (userFilterType === 'code' && valuePartner) {
      const isNumeric = /^\d+$/.test(valuePartner);
      if (isNumeric) {
        filter.partner_id = valuePartner;
      } else {
        filter.partner_code = valuePartner;
      }
    }

    if (userFilterType === 'name' && data?.name) filter.name = data.name;
    if (data?.email) filter.email = data.email;
    if (selectedUserType?.value !== undefined && selectedUserType?.value !== null) {
      filter.user_type_id = selectedUserType.value;
    }
    if (selectedStatus?.value !== undefined && selectedStatus?.value !== null) {
      filter.only_active = selectedStatus.value;
    }

    setParams((prev: any) => ({
      ...prev,
      filter,
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  }

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div className="SidebarUsersFilter" data-testid="SidebarUsersFilter">
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>USUÁRIO</label>
              <div className="d-flex align-items-center gap-3 mb-2">
                <div className="d-flex align-items-center gap-1">
                  <input
                    type="checkbox"
                    id="filterByCode"
                    checked={userFilterType === 'code'}
                    onChange={() => setUserFilterType('code')}
                  />
                  <label htmlFor="filterByCode" className="mb-0" style={{ cursor: 'pointer', fontSize: 12 }}>Filtrar por Código</label>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <input
                    type="checkbox"
                    id="filterByName"
                    checked={userFilterType === 'name'}
                    onChange={() => setUserFilterType('name')}
                  />
                  <label htmlFor="filterByName" className="mb-0" style={{ cursor: 'pointer', fontSize: 12 }}>Filtrar por Nome</label>
                </div>
              </div>
              {userFilterType === 'code' && (
                <InputSearchPartner
                  name="partner"
                  control={control}
                  setValue={setValue}
                  valuePartner={valuePartner}
                  setValuePartner={setValuePartner}
                />
              )}
              {userFilterType === 'name' && (
                <input
                  type="text"
                  className="form-control"
                  {...register('name')}
                />
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="email">E-MAIL</label>
              <input
                className="form-control"
                {...register('email')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>TIPO DE USUÁRIO</label>
              <ReactSelect
                isClearable
                options={userTypesOptions ?? []}
                value={selectedUserType}
                placeholder="Todos"
                className="form-control p-0"
                noOptionsMessage={() => 'Não há registros'}
                styles={customStyles}
                onChange={(e) => setSelectedUserType(e ?? null)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>STATUS</label>
              <ReactSelect
                isClearable
                options={statusOptions}
                value={selectedStatus}
                placeholder="Todos"
                className="form-control p-0"
                noOptionsMessage={() => 'Não há registros'}
                styles={customStyles}
                onChange={(e) => setSelectedStatus(e ?? null)}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
}

export default SidebarUsersFilter;
